export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'https://cfg-api.nimbles2p.com',//'https://dev-ssc-api-v2.nimbles2p.com', //'https://dev-admin-api-v2.nimbles2p.com',
  client_id:17,
};


 